import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { AVATAR_ASSET_PATHS } from '../../assets/avatars/humanAvatarAssetUrls';
import { useAppSelector } from '../../redux/store';
import { HUMAN_AVATAR_PART_DEFINITIONS } from '../../types/avatarTypes';
import { AvatarPartImageButton } from './avatarPartImageButton';
import { AvatarPartNoneButton } from './avatarPartNoneButton';
import { AvatarSubTypeHeader } from './avatarSubTypeHeader';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 5px;
`;
const HEADER_CSS = css `
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
`;
const PARTS_CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2px;
`;
function getPartImageTitle(partLabel, partIndex, subTypeLabel) {
    if (subTypeLabel) {
        return `${partLabel} (${subTypeLabel}) ${partIndex + 1}`;
    }
    return `${partLabel} ${partIndex + 1}`;
}
export const AvatarPartBrowser = ({ partType, onClickPartIndex, onClickBack }) => {
    // TODO: Improve this inefficient selector:
    const pendingPlayerAvatar = useAppSelector((state) => state.selfAvatar.avatar?.pendingAvatar);
    if (!pendingPlayerAvatar || pendingPlayerAvatar.type !== 'custom') {
        return null;
    }
    const { label: partLabel, optionalProperties, browseImageScale, subTypesDefinition } = HUMAN_AVATAR_PART_DEFINITIONS[partType];
    const currentIndex = pendingPlayerAvatar.avatar.properties.parts[partType].index;
    const currentSubType = pendingPlayerAvatar.avatar.properties.parts[partType].subType;
    const isOptional = !!optionalProperties;
    return (_jsxs("section", { "aria-label": `Browsing ${partLabel}`, css: CONTAINER_CSS, children: [_jsxs("div", { css: HEADER_CSS, children: [_jsx(IconButton, { size: 'small', onClick: onClickBack, color: 'primary', title: 'Back', children: _jsx(ArrowBackRoundedIcon, {}) }), _jsx(Typography, { children: partLabel })] }), isOptional && (_jsx(AvatarPartNoneButton, { isSelected: currentIndex === -1, onClick: () => {
                    onClickPartIndex(-1, undefined);
                } })), subTypesDefinition && _jsx(AvatarSubTypeHeader, { label: subTypesDefinition.defaultSubTypeLabel }), _jsx("div", { css: PARTS_CONTAINER_CSS, children: AVATAR_ASSET_PATHS[partType].map((imageUrl, i) => (_jsx(AvatarPartImageButton, { imageUrl: imageUrl, isSelected: currentIndex === i && !currentSubType, title: getPartImageTitle(partLabel, i, subTypesDefinition?.defaultSubTypeLabel), onClick: () => {
                        onClickPartIndex(i, undefined);
                    }, scale: browseImageScale }, i))) }), subTypesDefinition && (_jsx(_Fragment, { children: subTypesDefinition.additionalSubTypes.map((additionalSubType, i) => {
                    const { imageUrls, type, label: subTypeLabel } = additionalSubType;
                    return (_jsxs(_Fragment, { children: [_jsx(AvatarSubTypeHeader, { label: subTypeLabel }), _jsx("div", { css: PARTS_CONTAINER_CSS, children: imageUrls.map((imageUrl, i) => (_jsx(AvatarPartImageButton, { imageUrl: imageUrl, isSelected: currentIndex === i && currentSubType === type, title: getPartImageTitle(partLabel, i, subTypeLabel), onClick: () => {
                                        onClickPartIndex(i, type);
                                    }, scale: browseImageScale }, i))) }, i)] }));
                }) }))] }));
};
